import { Observable } from 'rxjs';
import { Collection } from './collections.model';

export abstract class CollectionsService {
    abstract getCollections(): Observable<Collection[]>;
    abstract getCollection(id: string): Observable<Collection>;
    abstract createCollection(collection: Collection): Observable<Collection>;
    abstract updateCollection(collection: Collection): Observable<Collection>;
    abstract duplicateCollection(id: string): Observable<Collection>;
    abstract deleteCollection(id: string): Observable<any>;
}
